// @flow

import { sendData } from '../../../webjam/websocket';
import {
    SET_AUDIO_CHANNEL,
    SET_AUDIO_CHANNEL_ADDITIONAL,
    SET_AUDIO_STEREO,
    SET_CIRCLE_PAN_CHANGE,
    SET_DELAY_LOCAL_CHANGE,
    SET_DEVICE_USER_NAME,
    SET_ORGANIZATION,
    SET_ORGANIZATION_LIST,
    SET_RECORDING_TYPE,
    SET_WHITEBOARD_ASSETS,
    SET_WHITEBOARD_CATEGORIES,
    SET_BUFFER_CHANGE_USER,
    SET_IS_BUFFER_CHANGE,
    SET_IS_DEVICE_LISTED,
    SET_TRANSLATE_MESSAGE,
    SET_MUTE_SPEAKING,
    SET_IS_RECORDING_LOADER,
    SET_RECORDING_TIMER,
    SET_IS_BUFFER_HOST_READY,
    SET_SCREEN_VIEW,
    SET_APP_BASE_CONFIG,
    SET_DEVICE_CONTAINER_STATUS,
    SET_RECORDING_MODAL_COUNT,
    SET_RECORDING_MODAL_ACTION,
    SET_RECORDING_EMAIL,
    SET_CHORD_DATA,
    SET_CHORD_IMG,
    SET_SHOW_RECORDING_MODAL,
    SET_SHOW_UPLOAD_MODAL,
    SET_PAID_ROOM_DETAIL,
    SET_STRIPE_ACCOUNT_CREATED,
    SET_STRIPE_ACCOUNT_VERIFIED,
    SET_TOOLS_OBJECT,
    SET_USERS_LIST_ARRAY,
    SET_IS_MY_RECORDINGS_MODAL,
    SET_MY_RECORDINGS_DATA,
    TOGGLE_LIGHTING_MENU_VISIBILITY,
    SET_ENABLE_RECORDING_MODAL,
    SET_ENABLE_WEBJAM_MODAL,
    SET_DISABLE_REC_ICON,
    SET_SHOW_CONNECT_POPUP,
    SET_STRIPE_ACCOUNT_REQUEST,
    SET_DUET_USER_ID,
    SET_STATE_MODEL,
    SET_PREJOIN_SCREEN_DEVICE_INIT,
    SET_THIRD_PARTY_MOD_EVENT,
    SET_DO_HANG_UP,
    SET_DEVICE_INFO_MESSAGE,
    SET_PREJOIN_ROOM_RT,
    SET_HOST_BUTTON_ACTION,
    SET_REG_DEVICES,
    SET_AVAILABLE_USER_IP,
    SET_CUSTOM_TOUR_ACTION,
    SET_OUT_AUTO_MANAGE,
    SET_DETECT_DEVICE_TIMER,
    SET_JOIN_WITHOUT_DEVICE,
    SET_BROWSER_DEVICE_STATUS,
    SET_PREJOIN_SCREEN_STEP_FLAG,
    SET_MEDIA_DEVICE_OVERLAY,
    SET_PREJOIN_SOCK_WAIT,
    SET_DEVICE_DETECTING,
    SET_ZENDESK_STATE,
    SET_MIXER_SETTINGS
} from './actionType';
import { SaveLog } from '../../../customise/Utils'

export function setAudioChannelSetting(inputAudioChannel: any) {
    return {
        type: SET_AUDIO_CHANNEL,
        audioChannelConfig: inputAudioChannel
    }
}

export function setAudioChannelAdditionalSetting(additionalChannelSetting: Boolean) {
    return {
        type: SET_AUDIO_CHANNEL_ADDITIONAL,
        additionalChannelSetting
    }
}

export function setDelayLocalChange(delayLocalChange: Boolean) {
    return {
        type: SET_DELAY_LOCAL_CHANGE,
        delayLocalChange
    }
}

export function setAudioStereo(isStereoChanged: Boolean) {
    return {
        type: SET_AUDIO_STEREO,
        isStereoChanged
    }
}

export function setOrganizationList(organizationList: Array) {
    return {
        type: SET_ORGANIZATION_LIST,
        organizationList
    }
}

export function setOrganization(authOrganization: any) {
    return {
        type: SET_ORGANIZATION,
        authOrganization
    }
}

export function setWhiteboardAssets(whiteboardAssets: any) {
    return {
        type: SET_WHITEBOARD_ASSETS,
        whiteboardAssets
    }
}

export function setWhiteboardCategories(whiteboardCategories: Array) {
    return {
        type: SET_WHITEBOARD_CATEGORIES,
        whiteboardCategories
    }
}

export function setChordsData(chordData: Object) {
    return {
        type: SET_CHORD_DATA,
        chordData
    }
}

export function setChordsImg(chordImg: Array) {
    return {
        type: SET_CHORD_IMG,
        chordImg
    }
}

export function setDefaultRecordingType(defaultRecordingType: any) {
    return {
        type: SET_RECORDING_TYPE,
        defaultRecordingType
    }
}

export function getDeviceUserName(deviceDetail: any, localUser: any) {

    return (dispatch) => {
        let deviceUser = deviceDetail?.myName;
        if (deviceDetail?.myName == "") {
            deviceUser = localUser.name;

            var message = {
                action: {
                    firstname: deviceUser,
                    lastname: '',
                    uniqueID: deviceDetail.uniqueId,
                },
                content: 'set-name',
                isBroadcast: true,
                sender: 'mobile',
            };

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------
            sendData(message, '', 1);
        }

        deviceUser = deviceUser + "___" + Math.random()
        if (deviceUser) {
            dispatch(setDeviceUserName(deviceUser))
        }
    }
}

export function setDeviceUserName(deviceUserName: any) {
    return {
        type: SET_DEVICE_USER_NAME,
        deviceUserName
    }
}

export function setCirclePanChange(isCirclePanChange: any) {
    return {
        type: SET_CIRCLE_PAN_CHANGE,
        isCirclePanChange
    }
}

export function setBufferChangeUser(bufferChangeUser: any) {
    return {
        type: SET_BUFFER_CHANGE_USER,
        bufferChangeUser
    }
}

export function setIsBufferChange(isBufferChange: Boolean) {
    return {
        type: SET_IS_BUFFER_CHANGE,
        isBufferChange
    }
}

export function setIsDeviceListed(isDeviceListed: Boolean) {
    return {
        type: SET_IS_DEVICE_LISTED,
        isDeviceListed
    }
}

export function setChatTranslateMessage(chatTranslateMessage: String, chatTranslateMessageSend: Boolean) {
    return {
        type: SET_TRANSLATE_MESSAGE,
        chatTranslateMessage,
        chatTranslateMessageSend
    };
}

export function setSpeakWhileMute(speakingWhileMute: any) {
    return {
        type: SET_MUTE_SPEAKING,
        speakingWhileMute
    };
}

export function setIsRecordingLoader(isRecordingLoader: Boolean) {
    return {
        type: SET_IS_RECORDING_LOADER,
        isRecordingLoader
    }
}

export function setRecordingTimer(recordingTimer: int) {
    return {
        type: SET_RECORDING_TIMER,
        recordingTimer
    }
}

export function setIsBufferHostReady(isBufferHostReady: Boolean) {
    return {
        type: SET_IS_BUFFER_HOST_READY,
        isBufferHostReady
    }
}

export function setScreenView(screenview: int) {
    return {
        type: SET_SCREEN_VIEW,
        screenview
    }
}

export function setAppBaseWebConfig(appBaseWebConfig: any) {
    return {
        type: SET_APP_BASE_CONFIG,
        appBaseWebConfig
    }
}

export function setDeviceContainerStatus(deviceContainerStatus: String, deviceContainerStatusFrom: String) {
    console.log("setDeviceContainerStatus =>", deviceContainerStatus, deviceContainerStatusFrom)
    return {
        type: SET_DEVICE_CONTAINER_STATUS,
        deviceContainerStatus,
    }
}

export function setRecordingModalCount(recordingModalCount: int) {
    return {
        type: SET_RECORDING_MODAL_COUNT,
        recordingModalCount
    }
}

export function setRecordingModalAction(recordingModalAction: String) {
    return {
        type: SET_RECORDING_MODAL_ACTION,
        recordingModalAction
    }
}

export function setRecordingEmail(recordingEmail: String) {
    return {
        type: SET_RECORDING_EMAIL,
        recordingEmail
    }
}

export function setshowRecordingModal(showRecordingModal: any) {
    return {
        type: SET_SHOW_RECORDING_MODAL,
        showRecordingModal
    }
}

export function setshowUploadModal(showUploadModal: Boolean) {
    return {
        type: SET_SHOW_UPLOAD_MODAL,
        showUploadModal
    }
}

export function setToolsObject(toolsObject: any) {
    return {
        type: SET_TOOLS_OBJECT,
        toolsObject
    }
}

export function setUsersListArray(usersListArray: Array) {
    if (usersListArray == undefined) {
        usersListArray = [];
    }
    return {
        type: SET_USERS_LIST_ARRAY,
        usersListArray
    }
}

export function setPaidRoomDetail(paidRoomDetail: Object) {
    return {
        type: SET_PAID_ROOM_DETAIL,
        paidRoomDetail
    }
}

export function setStripeAccountCreated(isStripeConnect: Boolean) {
    return {
        type: SET_STRIPE_ACCOUNT_CREATED,
        isStripeConnect
    }
}
export function setStripeAccountVerified(isStripeConnectVerified: String) {
    return {
        type: SET_STRIPE_ACCOUNT_VERIFIED,
        isStripeConnectVerified
    }
}

export function setIsMyRecordingsModal(isMyRecordingsModal: Boolean) {
    return {
        type: SET_IS_MY_RECORDINGS_MODAL,
        isMyRecordingsModal
    }
}

export function setMyRecordingsData(myRecordingsData: any) {
    return {
        type: SET_MY_RECORDINGS_DATA,
        myRecordingsData
    }
}

export function toggleLightingMenuVisibility(lightingMenuVisibility: any) {
    return {
        type: TOGGLE_LIGHTING_MENU_VISIBILITY,
        lightingMenuVisibility
    }
}

export function setEnableRecordingModal(enableRecordingModal: any) {
    return {
        type: SET_ENABLE_RECORDING_MODAL,
        enableRecordingModal
    }
}

export function setEnableWebjamModal(enableWebjamModal: any) {
    return {
        type: SET_ENABLE_WEBJAM_MODAL,
        enableWebjamModal
    }
}

export function setDisableRecIcon(disableRecIcon: any, recordingInitiator: any) {
    return {
        type: SET_DISABLE_REC_ICON,
        disableRecIcon,
        recordingInitiator: recordingInitiator || null
    }
}

export function setShowConnectPopup(showConnectPopup: any) {
    return {
        type: SET_SHOW_CONNECT_POPUP,
        showConnectPopup
    }
}

export function setStripeRequesting(isStripeRequesting: boolean) {
    return {
        type: SET_STRIPE_ACCOUNT_REQUEST,
        isStripeRequesting
    }
}

export function setDuetUserId(duetUserId: boolean) {
    return {
        type: SET_DUET_USER_ID,
        duetUserId
    }
}

export function setToolModal(toolModal: Object) {
    return {
        type: SET_STATE_MODEL,
        toolModal
    }
}

export function setPrejoinDeviceConnection(prejoinDeviceConnection: String, remoteDeviceId: String | undefined) {
    return {
        type: SET_PREJOIN_SCREEN_DEVICE_INIT,
        prejoinDeviceConnection,
        remoteDeviceId
    }
}

export function setThirdPartyModEvent(thirdPartyModEvent: any) {
    return {
        type: SET_THIRD_PARTY_MOD_EVENT,
        thirdPartyModEvent
    }
}

export function setDoHangUp(doHangUpRec: boolean) {
    return {
        type: SET_DO_HANG_UP,
        doHangUpRec
    }
}

export function setDeviceInfoMessage(deviceInfoMessages: Object, additional: any = null) {
    return {
        type: SET_DEVICE_INFO_MESSAGE,
        deviceInfoMessages
    }
}

export function setPrejoinScreenDetail(prejoinScreenDetail: Object) {
    return {
        type: SET_PREJOIN_ROOM_RT,
        prejoinScreenDetail
    }
}

export function setHostButtonAction(hostButtonAction: boolean) {
    return {
        type: SET_HOST_BUTTON_ACTION,
        hostButtonAction
    }
}

export function setOutAutoManage(outAutoManage: boolean) {
    return {
        type: SET_OUT_AUTO_MANAGE,
        outAutoManage
    }
}

export function setRegisteredDevice(registeredDevice: Array, allUserDevices: any, from = null) {
    return {
        type: SET_REG_DEVICES,
        registeredDevice,
        allUserDevices
    }
}

export function setAvilableUserIP(availableUserIp: String) {
    return {
        type: SET_AVAILABLE_USER_IP,
        availableUserIp
    }
}

export function setCustomTourAction(customTourAction: boolean) {
    return {
        type: SET_CUSTOM_TOUR_ACTION,
        customTourAction
    }
}

export function setDetectDeviceTimer(detectDeviceTimer: any) {

    return {
        type: SET_DETECT_DEVICE_TIMER,
        detectDeviceTimer
    }
}

export function setJoinRoomWithoutDevice(joinRoomWithoutDevice: boolean, from: any = null) {
    return {
        type: SET_JOIN_WITHOUT_DEVICE,
        joinRoomWithoutDevice
    }
}

export function setBrowserDeviceStatus(browserDeviceStatus: any) {
    return {
        type: SET_BROWSER_DEVICE_STATUS,
        browserDeviceStatus
    }
}

export function setPrejoinStepFlag(prejoinStepFlag: String) {
    return {
        type: SET_PREJOIN_SCREEN_STEP_FLAG,
        prejoinStepFlag
    }
}

export function setMediaDeviceOverLay(mediaDeviceOverlay: boolean) {
    return {
        type: SET_MEDIA_DEVICE_OVERLAY,
        mediaDeviceOverlay
    }
}

export function setPrejoinSocketDWaiting(socketDeviceWaiting: boolean) {
    return {
        type: SET_PREJOIN_SOCK_WAIT,
        socketDeviceWaiting
    }
}

export function setUserDeviceDetecting(isUserDeviceDetecting: boolean) {
    return {
        type: SET_DEVICE_DETECTING,
        isUserDeviceDetecting
    }
}

export function setZendeskState(isZendeskOpen: boolean) {

    return {
        type: SET_ZENDESK_STATE,
        isZendeskOpen
    }
}

export function showMixerSettingsModal(isShowMixerSettings: boolean) {
    return {
        type: SET_MIXER_SETTINGS,
        isShowMixerSettings
    }
}